module.exports = __webpack_public_path__ + "static/img/logistics-h5-7.7cc75a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5-7.png
// module id = WFnU
// module chunks = 34